import { useEffect, useState } from "react"
import { fetchData } from "../utils/api";

const useFetchData = (url) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading("Loading...");
        setData(null);
        setError(null);
        fetchData(url)
            .then((res) => {
                setLoading(false);
                setData(res);
            })
            .catch((err) => {
                setLoading(false);
                setError("Error Found:", err);
            })
    }, [url]);
    return { data, loading, error };
}

export default useFetchData;